class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();

    function swymCallbackFn(swat) {
      document.addEventListener('swym:recommendations-loaded', function () {
        swat.initializeActionButtons('[data-recommendations]');
      });
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }

  init() {
    this.section = this.querySelector('[data-recommendations]');

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('[data-recommendations]');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.section.innerHTML = recommendations.innerHTML;
          this.section.classList.remove('hidden');

          document.dispatchEvent(
            new CustomEvent('swym:recommendations-loaded'),
          );
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
